import { jsx as _jsx } from "react/jsx-runtime";
import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/pro-light-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import { useTranslation } from 'react-i18next';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentExpandModulesSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentExpandModulesSchema';
import { Button } from 'src/shared/components/button';
import { Icon } from 'src/shared/components/icon';
import { Tooltip } from 'src/shared/components/tooltip';
export function ExpandAll({ allModulesAreOpen, toggleAllModules }) {
    const { t } = useTranslation();
    const label = t(allModulesAreOpen ? 'content_list.tools.collapse' : 'content_list.tools.expand');
    const icon = allModulesAreOpen
        ? faArrowDownLeftAndArrowUpRightToCenter
        : faArrowUpRightAndArrowDownLeftFromCenter;
    function handleToggleAllModules() {
        toggleAllModules();
        DataHubService.sendEvent({
            schema: new ClickContentExpandModulesSchema({
                actionType: allModulesAreOpen ? 'COLLAPSE' : 'EXPAND'
            })
        });
    }
    return (_jsx(Tooltip, { text: label, className: "ml-2", children: _jsx(Button, { size: "large", context: "neutral", "aria-label": label, variation: "secondary", onClick: handleToggleAllModules, icon: _jsx(Icon, { icon: icon }) }) }, label));
}
